/**
 * @flow
 * @relayHash f2c9f56042b34a82b160e6555ba81168
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type createHyreferralCampaignInput = {|
  clientMutationId?: ?string,
  title: string,
  propertyId: string,
  reward?: ?number,
  emailSubject?: ?string,
  emailBody?: ?string,
  emailSms?: ?string,
  ctaDesign?: ?string,
  ctaText?: ?string,
  bannerText?: ?string,
  pitchMessage?: ?string,
  emailEnabled?: ?boolean,
  smsEnabled?: ?boolean,
  facebookEnabled?: ?boolean,
  twitterEnabled?: ?boolean,
  image?: ?string,
  residentInviteImage?: ?string,
  residentInviteEmailSubject?: ?string,
  residentInviteEmailBody?: ?string,
  residentInviteSms?: ?string,
  residentInviteSocialContent?: ?string,
  residentDiscountImage?: ?string,
  residentDiscountEmailSubject?: ?string,
  residentDiscountEmailBody?: ?string,
  residentDiscountEmailSms?: ?string,
  tourCtaText?: ?string,
  tourCtaUrl?: ?string,
  contactCtaText?: ?string,
  contactCtaUrl?: ?string,
  residentEnrollHeader?: ?string,
  residentEnrollFooter?: ?string,
  rewardEmailHeader?: ?string,
  friendInviteEmailHeader?: ?string,
  friendInviteMenuHeader?: ?string,
  friendInviteMenuBody?: ?string,
  residentBannerTitle?: ?string,
  popupMessage?: ?string,
  popupTitle?: ?string,
  residentThankYouEmailSubject?: ?string,
  residentThankYouEmailTitle?: ?string,
  residentThankYouEmailBody?: ?string,
  residentThankYouImage?: ?string,
  landingPageContent?: ?string,
  landingPageTitle?: ?string,
  landingPageImage?: ?string,
  emailValidationStatus?: ?boolean,
|};
export type createCampaignMutationVariables = {|
  input: createHyreferralCampaignInput
|};
export type createCampaignMutationResponse = {|
  +createHyreferralCampaign: ?{|
    +clientMutationId: ?string,
    +hyreferralCampaign: ?{|
      +id: string,
      +propertyId: string,
      +enrollUrl: ?string,
      +title: string,
      +reward: ?number,
      +emailSubject: ?string,
      +emailBody: ?string,
      +emailSms: ?string,
      +ctaDesign: ?string,
      +ctaText: ?string,
      +bannerText: ?string,
      +pitchMessage: ?string,
      +residentEnrollHeader: ?string,
      +residentEnrollFooter: ?string,
      +emailEnabled: ?boolean,
      +smsEnabled: ?boolean,
      +facebookEnabled: ?boolean,
      +twitterEnabled: ?boolean,
      +residentInviteEmailSubject: ?string,
      +residentInviteEmailBody: ?string,
      +residentInviteSms: ?string,
      +residentInviteSocialContent: ?string,
      +residentDiscountEmailSubject: ?string,
      +residentDiscountEmailBody: ?string,
      +residentDiscountEmailSms: ?string,
      +tourCtaText: ?string,
      +tourCtaUrl: ?string,
      +contactCtaText: ?string,
      +contactCtaUrl: ?string,
      +active: boolean,
      +image: ?{|
        +id: string,
        +fileType: string,
        +fileSize: number,
        +fileUrl: string,
        +dimension: ?string,
        +thumbnailUrl: ?string,
      |},
      +residentInviteImage: ?{|
        +id: string,
        +fileType: string,
        +fileSize: number,
        +fileUrl: string,
        +dimension: ?string,
        +thumbnailUrl: ?string,
      |},
      +residentDiscountImage: ?{|
        +id: string,
        +fileType: string,
        +fileSize: number,
        +fileUrl: string,
        +dimension: ?string,
        +thumbnailUrl: ?string,
      |},
      +abortResidentInviteCampaignId: ?string,
      +shortTourCtaUrl: ?string,
      +shortEnrollUrl: ?string,
      +propertyName: ?string,
      +rewardEmailHeader: ?string,
      +friendInviteEmailHeader: ?string,
      +friendInviteMenuHeader: ?string,
      +friendInviteMenuBody: ?string,
      +residentBannerTitle: ?string,
      +popupMessage: ?string,
      +popupTitle: ?string,
      +residentInviteCampaignTested: ?boolean,
      +residentThankYouEmailSubject: ?string,
      +residentThankYouEmailTitle: ?string,
      +residentThankYouEmailBody: ?string,
      +landingPageContent: ?string,
      +residentThankYouImage: ?{|
        +id: string,
        +fileType: string,
        +fileSize: number,
        +fileUrl: string,
        +dimension: ?string,
        +thumbnailUrl: ?string,
      |},
      +landingPageTitle: ?string,
      +landingPageImage: ?{|
        +id: string,
        +fileType: string,
        +fileSize: number,
        +fileUrl: string,
        +dimension: ?string,
        +thumbnailUrl: ?string,
      |},
      +emailValidationStatus: ?boolean,
    |},
  |}
|};
export type createCampaignMutation = {|
  variables: createCampaignMutationVariables,
  response: createCampaignMutationResponse,
|};
*/


/*
mutation createCampaignMutation(
  $input: createHyreferralCampaignInput!
) {
  createHyreferralCampaign(input: $input) {
    clientMutationId
    hyreferralCampaign {
      id
      propertyId
      enrollUrl
      title
      reward
      emailSubject
      emailBody
      emailSms
      ctaDesign
      ctaText
      bannerText
      pitchMessage
      residentEnrollHeader
      residentEnrollFooter
      emailEnabled
      smsEnabled
      facebookEnabled
      twitterEnabled
      residentInviteEmailSubject
      residentInviteEmailBody
      residentInviteSms
      residentInviteSocialContent
      residentDiscountEmailSubject
      residentDiscountEmailBody
      residentDiscountEmailSms
      tourCtaText
      tourCtaUrl
      contactCtaText
      contactCtaUrl
      active
      image {
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
      residentInviteImage {
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
      residentDiscountImage {
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
      abortResidentInviteCampaignId
      shortTourCtaUrl
      shortEnrollUrl
      propertyName
      rewardEmailHeader
      friendInviteEmailHeader
      friendInviteMenuHeader
      friendInviteMenuBody
      residentBannerTitle
      popupMessage
      popupTitle
      residentInviteCampaignTested
      residentThankYouEmailSubject
      residentThankYouEmailTitle
      residentThankYouEmailBody
      landingPageContent
      residentThankYouImage {
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
      landingPageTitle
      landingPageImage {
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
      emailValidationStatus
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "createHyreferralCampaignInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "fileType",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "fileSize",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "fileUrl",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "dimension",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "thumbnailUrl",
    "args": null,
    "storageKey": null
  }
],
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createHyreferralCampaign",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "createHyreferralCampaignPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyreferralCampaign",
        "storageKey": null,
        "args": null,
        "concreteType": "HyreferralCampaign",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enrollUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "reward",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "emailSubject",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "emailBody",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "emailSms",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ctaDesign",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ctaText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "bannerText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pitchMessage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentEnrollHeader",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentEnrollFooter",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "emailEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "smsEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebookEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitterEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentInviteEmailSubject",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentInviteEmailBody",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentInviteSms",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentInviteSocialContent",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentDiscountEmailSubject",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentDiscountEmailBody",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentDiscountEmailSms",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tourCtaText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tourCtaUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactCtaText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactCtaUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "active",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "image",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "residentInviteImage",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "residentDiscountImage",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "abortResidentInviteCampaignId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shortTourCtaUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shortEnrollUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rewardEmailHeader",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "friendInviteEmailHeader",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "friendInviteMenuHeader",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "friendInviteMenuBody",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentBannerTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "popupMessage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "popupTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentInviteCampaignTested",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentThankYouEmailSubject",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentThankYouEmailTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentThankYouEmailBody",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "landingPageContent",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "residentThankYouImage",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "landingPageTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "landingPageImage",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "emailValidationStatus",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "createCampaignMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "createCampaignMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "createCampaignMutation",
    "id": null,
    "text": "mutation createCampaignMutation(\n  $input: createHyreferralCampaignInput!\n) {\n  createHyreferralCampaign(input: $input) {\n    clientMutationId\n    hyreferralCampaign {\n      id\n      propertyId\n      enrollUrl\n      title\n      reward\n      emailSubject\n      emailBody\n      emailSms\n      ctaDesign\n      ctaText\n      bannerText\n      pitchMessage\n      residentEnrollHeader\n      residentEnrollFooter\n      emailEnabled\n      smsEnabled\n      facebookEnabled\n      twitterEnabled\n      residentInviteEmailSubject\n      residentInviteEmailBody\n      residentInviteSms\n      residentInviteSocialContent\n      residentDiscountEmailSubject\n      residentDiscountEmailBody\n      residentDiscountEmailSms\n      tourCtaText\n      tourCtaUrl\n      contactCtaText\n      contactCtaUrl\n      active\n      image {\n        id\n        fileType\n        fileSize\n        fileUrl\n        dimension\n        thumbnailUrl\n      }\n      residentInviteImage {\n        id\n        fileType\n        fileSize\n        fileUrl\n        dimension\n        thumbnailUrl\n      }\n      residentDiscountImage {\n        id\n        fileType\n        fileSize\n        fileUrl\n        dimension\n        thumbnailUrl\n      }\n      abortResidentInviteCampaignId\n      shortTourCtaUrl\n      shortEnrollUrl\n      propertyName\n      rewardEmailHeader\n      friendInviteEmailHeader\n      friendInviteMenuHeader\n      friendInviteMenuBody\n      residentBannerTitle\n      popupMessage\n      popupTitle\n      residentInviteCampaignTested\n      residentThankYouEmailSubject\n      residentThankYouEmailTitle\n      residentThankYouEmailBody\n      landingPageContent\n      residentThankYouImage {\n        id\n        fileType\n        fileSize\n        fileUrl\n        dimension\n        thumbnailUrl\n      }\n      landingPageTitle\n      landingPageImage {\n        id\n        fileType\n        fileSize\n        fileUrl\n        dimension\n        thumbnailUrl\n      }\n      emailValidationStatus\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '58e27e65a4a2a7516118187061992f72';
module.exports = node;
